import React from "react";
import { Link } from "react-router-dom";

const Refund = () => {
  return (
    <>
      <div class="middle-section">
        <div class="container">
          <div class="cms-section">
            <div class="heading">
              <h2>Refund</h2>
            </div>
            <div class="whitebox">
              <p>
                <strong>For Members (Users)</strong>
              </p>
              <p>
                We do not charge our end users to play any live fantasy game.
                The platform is free to register, login and play any game of
                your choice. We are not required to provide a refund or
                replacement to any end user of our platform 'MyClubtap'.
              </p>
              <br></br>
              <p>
                <strong>
                  Conditions for MyClubtap PRO Membership Cancellation For
                  Members (Users)
                </strong>
              </p>
              <p>
                Members can cancel a PRO Membership within 7-days of purchase of
                PRO Membership;
              </p>
              <p>Full refund is issued within 2-3 business days;</p>
              <p>
                No cancellation/refund available after the 7-day period from the
                date and time of purchase;
              </p>
              <p>
                Email help@myclubtap.com for any issues with your MyClubtap PRO
                Membership.
              </p>
              <br></br>
              <p>
                <strong>For Clubs or Leagues</strong>
              </p>
              <p>
                We do not charge Clubs or Leagues for the setup of their fantasy
                game. The platform is free to register, login and setup of a
                fantasy game of the Clubs and Leagues, with access to full suite
                of Basic and PRO admin features.
              </p>
              <p>
                Clubs or Leagues have the option to not proceed with the setup
                at any points before the activation of their fantasy game.
              </p>
              <p>
                Activation of a game for Starter Plan account holders requires a
                payment of the game activation fees ($99), which is
                non-refundable.
              </p>
              <p>
                We are not required to provide a refund once a fantasy game
                (under Starter Plan) has been paid for and activated, or a
                service (Fee Collection or Scorer+) has been purchased on our
                platform 'MyClubtap'. But you can choose to request a refund if
                your access to the platform ('MyClubtap') has a major problem.
              </p>
              <p>This is when the access:</p>
              <p>
                has a problem that would have stopped someone from playing your
                fantasy game or it is unsafe or unsuitable to play;
              </p>
              <p>
                is significantly different from the sample or description
                provided to the designated club contact doesn't do what we said
                it would, or what you asked for and can't be easily fixed;
              </p>
              <p>
                If the problem is not major, we will repair your access within a
                reasonable time. If it is not repaired in a reasonable time you
                can choose to request a refund. We request you to reach out to
                us by sending an email to{" "}
                <a href="mailto:refund@myclubtap.com">refund@myclubtap.com</a>,
                for any such issues and we will ensure a resolution at the
                earliest.
              </p>
              <p>Please keep your proof of purchase – e.g. your invoice.</p>
              <br></br>
              <p>
                <strong>
                  Conditions for Game Pass Cancellation From Members on behalf
                  of a Club or League
                </strong>
              </p>
              <p>
                No cancellation/refund are available for payment of Game Pass;
              </p>
              <p>
                Any available refunds are the sole responsibility of the Club or
                League fantasy game owner.
              </p>
              <p>
                Members must contact the Game Administrator of the game for any
                Game Pass refund request.
              </p>
              <p>
                Email for respective Club or League game administrators are
                available on the Game's Account Hub.
              </p>
              <br></br>
              <p>
                <strong>For MyClubtap Partner Offers</strong>
              </p>
              <p>
                We are not required to provide a refund for any purchases made
                by you using discount offers of MyClubtap partners. MyClubtap
                only acts as an intermediary between you ('Members') and our
                Partners, whose offer(s) are listed and available for use on the
                Partners section of our website. Refund policy of the concerned
                merchant applies at all times. MyClubtap is not or cannot be
                held liable for refund on any products purchased via the
                MyClubtap Partners and Offers.
              </p>
              <br></br>
              <p>
                <strong>For Delivery Costs</strong>
              </p>
              <p>
                MyClubtap is not responsible for the delivery of any products
                purchased on Partners website(s). It is the sole responsibility
                of the merchant to ensure the delivery of the product(s) to its
                intended 'Members'. For any concerns or further information, you
                can ask us for guidance by sending us an email on
                help@myclubtap.com or by directly reaching out to the specified
                Partner.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Refund;
